import { render, staticRenderFns } from "./LimitExceededFreemium.vue?vue&type=template&id=ef875344&scoped=true&"
import script from "./LimitExceededFreemium.vue?vue&type=script&lang=js&"
export * from "./LimitExceededFreemium.vue?vue&type=script&lang=js&"
import style0 from "./LimitExceededFreemium.vue?vue&type=style&index=0&id=ef875344&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef875344",
  null
  
)

export default component.exports